import { motion } from "framer-motion";
import { PROOF_PHOTOS } from "@/constants/business";

export default function ProofsSection() {
  return (
    <section data-testid="proofs-section" className="py-14 md:py-20 px-4 md:px-8 bg-graylight">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Notre méthode</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3 mb-3">
            Des transports préparés et organisés avec soin
          </h2>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
            Protection des biens, sanglage et chargement organisé : chaque intervention est préparée selon le volume, les accès et les objets à transporter.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-4">
          {PROOF_PHOTOS.map((photo, i) => (
            <motion.figure
              key={photo.src}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.06 }}
              data-testid={`proof-photo-${i}`}
              className="bg-white border border-gray-200 rounded-2xl overflow-hidden"
            >
              <div className="relative">
                <img src={photo.src} alt={photo.alt} loading="lazy" className="w-full h-52 md:h-60 object-cover" />
                <span className="absolute top-2.5 right-2.5 bg-white/90 text-navy/60 text-[10px] font-semibold rounded-full px-2 py-0.5">
                  Photo d'illustration
                </span>
              </div>
              <figcaption className="px-4 py-3 text-sm font-medium text-navy">{photo.caption}</figcaption>
            </motion.figure>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-5">
          Les photos de nos interventions réelles seront publiées prochainement dans cette galerie.
        </p>
      </div>
    </section>
  );
}
